import { convertToQueryString } from 'app/shared/functions';
import { HttpClient } from 'app/library/client';
import { IListFilter, ResponseBase, ResponseContentBase, ResponseListBase } from "app/shared";
import { ArtistEntity } from './types';
import { getEndpoint } from 'app/utils/service';

export class ArtistService {

    /** It gets all Artist. */
    async getArtists(options: IListFilter): Promise<ResponseBase<ResponseListBase<ArtistEntity[]>>> {
        return HttpClient.getClient().get(getEndpoint('/artist/search') + `?${convertToQueryString(options)}`);
    }

    /** It get spesific Artist by Artist id */
    async getArtist(id: string, language: string): Promise<ResponseBase<ResponseContentBase<ArtistEntity>>> {
        return HttpClient.getClient().get(getEndpoint('/artist/') + id + `?language=${language || "en"}`);
    }

    /** It creates Artist by request */
    async createArtist(request: ArtistEntity): Promise<ResponseBase<ResponseContentBase<ArtistEntity>>> {
        return HttpClient.getClient().post(getEndpoint('/artist/'), request);
    }

    /** It updates spesific Artist by id */
    async updateArtist(request: ArtistEntity): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().patch(getEndpoint('/artist/') + request.id, request);
    }

    /** It deletes spesific Artist by id */
    async deleteArtist(id: string): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().delete(getEndpoint('/artist/') + id);
    }
}
